import { useState } from 'react';

export const useImagePreview = () => {
  const [openImagePreview, setOpenImagePreview] = useState<{ show: boolean; url: string | null }>({
    show: false,
    url: null
  });

  const handleCloseImagePreview = () => {
    setOpenImagePreview({ show: false, url: null });
  };

  const handleOpenImagePreview = (url: string) => {
    setOpenImagePreview({ show: true, url });
  };

  return { openImagePreview, handleOpenImagePreview, handleCloseImagePreview };
};
